import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=425d7ed9&scoped=true&"
import script from "./SidebarBlock.vue?vue&type=script&lang=js&"
export * from "./SidebarBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d7ed9",
  null
  
)

export default component.exports